import formCom from '../components/components-items/form-com.vue';


// 为组件添加 install 方法，用于按需引入
formCom.install = function (Vue) {
    Vue.component('mitee-from', formCom)
}

export default formCom